var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page',{attrs:{"flex-column":"","card-content":""},on:{"gotMenuName":function($event){_vm.nameLabel = $event}}},[_c('dictionary-enum-edit',{attrs:{"name-label":_vm.nameLabel,"code":_vm.getCode(),"with-label":_vm.withLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }